import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

import { useGetSites } from '../../../../../../../../hooks/api/sites';
import useDialogContext from '../../../../../../../../hooks/dialog/useDialogContext';

const ManageSitesButton = (): JSX.Element | null => {
  const { t } = useTranslation();
  const { openDialog } = useDialogContext();
  const { data: sites = [] } = useGetSites();

  if (sites.length === 0) {
    return null;
  }

  return (
    <Button
      className='w-full md:max-w-fit flex'
      label={t('certificatesPage.tabs.myCertificatesTab.buttons.manageSites')}
      outlined
      onClick={() => {
        openDialog('manage-sites-dialog');
      }}
    />
  );
};

export default ManageSitesButton;
